module.exports = __webpack_public_path__ + "static/media/cloud_1.c9b04739.png";